import { render } from "./CorrectionRequestDialog.vue?vue&type=template&id=7c269e31&scoped=true"
import script from "./CorrectionRequestDialog.vue?vue&type=script&lang=js"
export * from "./CorrectionRequestDialog.vue?vue&type=script&lang=js"

import "./CorrectionRequestDialog.vue?vue&type=style&index=0&id=7c269e31&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c269e31"]])

export default __exports__